import React from "react";
import Logo from "../../assests/logo.jpeg";

const Footer = () => {
  return (
    <div className="bg-light">
      <p className="text-center">
        Powered by <img src={Logo} alt="footer" style={{ width: 20 }} />
      </p>
    </div>
  );
};

export default Footer;
